/* eslint-disable max-lines */
import { getOpportunityList, getMyCusomterList, getHomePageContract, getHomepageCustomerManagerArchivePage } from '@/api/homePageApi.js';
import iconQuestion from '@/assets/images/icon-question.png';
import iconOpenEyes from '@/assets/images/icon-open-eyes.png';
import iconCloseEyes from '@/assets/images/icon-close-eyes.png';
import utils from '@/components/utils/common.js';
import store from '@/store';
import Decimal from 'decimal.js';
import { customerFormConfig, opportunityFormConfig, contractFormConfig, registrationFormConfig } from './tableItem/form.config.js';
const { userCode } = store.getters.user;
const customerlevelMap = {
    '所有': '2,4,5,6,7',
    'TOP': '4',
    '行业CKA': '5',
    '属地CKA': '6',
    '无收入CKA': '7',
    '普通': '2',
    'CKA': '5'
};
const setOwnerList = data => {
    if (!(Array.isArray(data) && data.length)) return {};
    const ownerNameObj = {};
    // eslint-disable-next-line no-unused-expressions
    data?.forEach((it, index) => {
        const ownerName = 'ownerName' + (index + 1);
        const ownerCode = 'ownerCode' + (index + 1);
        const ownerRatio = 'ownerRatio' + (index + 1);
        ownerNameObj[ownerName] = it.ownerName;
        ownerNameObj[ownerCode] = it.ownerCode;
        ownerNameObj[ownerRatio] = it.ownerRatio;
    });
    return ownerNameObj;
};
const getOtherTime = () => {
    // 获取当前时间（精确到毫秒）
    const startTime = new Date();

    // 计算未来3个月月底的最后一毫秒
    const endTime = new Date(startTime);
    startTime.setHours(0, 0, 0, 0); // 设置为当天的开始时刻
    endTime.setMonth(endTime.getMonth() + 4); // 跳到4个月后的同一天
    endTime.setDate(0); // 设置为上个月的最后一天
    // eslint-disable-next-line no-magic-numbers
    endTime.setHours(23, 59, 59, 999); // 设置为当天的最后时刻
    return {
        startTime: utils.formatDateTime(startTime),
        endTime: utils.formatDateTime(endTime)
    };
};
function getCustomerLevelData(level) {
    if (!level) return [];
    const _level = customerlevelMap[level];
    if (_level.length) {
        return _level.split(',');
    }
    return [];
}
const formatParams = (params) => {
    const professionalCompanyList = [];
    let ebcdCodeArr = [];
    if (params.crmSearchData.ebcdCode) {
        ebcdCodeArr = params.crmSearchData.ebcdCode;
    }
    ebcdCodeArr.forEach((item, index) => {
        if (item.indexOf(',') >= 0) {
            const arr = item.split(',');
            arr.forEach((it, i) => {
                professionalCompanyList.push(it);
            });
        } else {
            professionalCompanyList.push(item);
        }
    });
    const formatParams = {
        regionCodeList: params.crmSearchData.areaCode,
        professionalCompanyList: professionalCompanyList,
        industryCategoriesCodeList: params.crmSearchData?.industryCategory?.map(it => it[0]) || [],
        companyCodeList: params.crmSearchData.subBranchCode,
        customerLevelCodeList: getCustomerLevelData(params.crmSearchData.customerlevelName),
        transactionClassCode: '2',
        customerChannelList: ['2']
    };
    delete params.crmSearchData;
    return {
        ...params,
        ...formatParams
    };
};
export const formatValue = (value) => {
    if (['', null, undefined].includes(value)) return null;
    // 判断是否为百分比
    const isPercentage = typeof value === 'string' && value.includes('%');

    // 使用Decimal处理数值
    let decimalValue;
    try {
        // 移除百分号和逗号
        const cleanValue = value?.toString().replace(/%/g, '').replace(/,/g, '');
        decimalValue = new Decimal(cleanValue);
    } catch (e) {
        return value;
    }

    if (isPercentage) {
        // 百分比处理
        if (decimalValue.abs().lt(100)) {
            // 绝对值小于100%，保留两位小数
            return decimalValue.toFixed(2) + '%';
        } else {
            // 绝对值大于等于100%，截断小数部分（修复取整问题）
            // 使用truncated()方法截断而不是四舍五入
            const truncatedValue = decimalValue.toDecimalPlaces(0);
            // 添加千分位分隔符
            return truncatedValue.toNumber().toLocaleString('en-US') + '%';
        }
    } else {
        // 普通数值处理
        if (decimalValue.abs().lt(100)) {
            // 绝对值小于100，保留两位小数
            return decimalValue.toFixed(2);
        } else {
            // 绝对值大于等于100，四舍五入并展示千分位
            const roundedValue = decimalValue.toDecimalPlaces(0);
            // 添加千分位分隔符
            return roundedValue.toNumber().toLocaleString('en-US');
        }
    }
};
export const config = {
    name: 'homePage',
    selection: true,
    index: false,
    columns: [
        {
            label: '用户',
            prop: 'ownerName',
            align: 'center'
        },
        {
            label: '类别',
            prop: 'typeName',
            align: 'center'
        },
        {
            label: '收入达成（万）',
            prop: 'achievement',
            moreHeader: true,
            content: `基层：按当前提成分配规则分摊到本人的收入（未定稿）；
管理层：本人所辖区域/行业的客户总收入（未定稿）；`,
            icon: iconQuestion,
            iconOpen: iconOpenEyes,
            iconClose: iconCloseEyes,
            children: [{

                label: '当月',
                icon: iconQuestion,
                prop: 'monthIncomeAchievement',
                content: `基于昨天所在月份的收入汇总`,
                align: 'center'
            }, {
                label: '累计',
                icon: iconQuestion,
                prop: 'cumulativeIncomeAchievement',
                content: `本年1月1日至昨天的收入汇总`,
                align: 'center'
            }]
        },
        {
            label: '过程提成（元）',
            prop: 'commission',
            moreHeader: true,
            content: `过程提成仅供参考，提成比例如下
1、核心（存量：1.96‰，增量：7.82‰）
2、非核心（存量：0.98‰，增量：3.91‰）
3、送装/小件（存量：0.49‰，增量：1.96‰）`,
            icon: iconQuestion,
            iconOpen: iconOpenEyes,
            iconClose: iconCloseEyes,
            children: [{
                label: '当月',
                // icon: iconQuestion,
                prop: 'monthProcessRoyalty',
                // content: '',
                align: 'center'
            }, {
                label: '累计',
                // icon: iconQuestion,
                prop: 'cumulativeProcessRoyalty',
                // content: '',
                align: 'center'
            }]
        },
        {
            label: '年底提成',
            prop: 'annualBudgetRoyalty',
            moreHeader: true,
            iconOpen: iconOpenEyes,
            iconClose: iconCloseEyes,
            children: [{
                label: '年度责任制累计得分',
                width: 145,
                prop: 'annualCumulativeScore',
                icon: iconQuestion,
                content: `年度责任制累计得分为截止上月的责任制达成结果`,
                time: true,
                align: 'center'
            }, {
                label: '年底预计提成（元）',
                width: 145,
                prop: 'annualBudgetRoyalty',
                icon: iconQuestion,
                content: `年底预计提成为按当前责任制达成模拟测算，实际发放以年底最终达成为准`,
                align: 'center'
            }]
        },
        {
            label: '累计提成',
            prop: 'cumulativeRoyalty',
            align: 'center',
            icon: iconQuestion,
            iconOpen: iconOpenEyes,
            iconClose: iconCloseEyes,
            content: `=责任制提成+过程提成`
        }
    ],
    otherRoleColumns: [
        {
            label: '用户',
            prop: 'ownerName',
            align: 'center'
        },
        {
            label: '类别',
            prop: 'typeName',
            align: 'center'
        },
        {
            label: '当月收入达成（万）',
            prop: 'monthIncomeAchievement',
            icon: iconQuestion,
            content: `基于昨天所在月份的收入汇总`,
            align: 'center'
        },
        {
            label: '累计收入达成（万）',
            prop: 'cumulativeIncomeAchievement',
            icon: iconQuestion,
            content: `本年1月1日至昨天的收入汇总`,
            align: 'center'
        },
        {
            label: '年度责任制累计得分',
            prop: 'annualCumulativeScore',
            icon: iconQuestion,
            content: `年度责任制累计得分为截止上月的责任制达成结果`,
            align: 'center',
            time: true,
            type: 'slot'
        },
        {
            label: '责任制排名',
            prop: 'respRanking',
            align: 'center'
        }
    ]
};

export const opportunityConfig = {
    name: 'opportunityConfig',
    selection: true,
    index: false,
    columns: [
        {
            label: '商机编码',
            prop: 'opportunityCode',
            minWidth: 80
        },
        {
            label: '商机名称',
            prop: 'opportunityName',
            type: 'slot',
            minWidth: 100
        },
        {
            label: '窗口期',
            prop: 'winPeriodWid',
            width: '160px',
            sort: 'custom'
        },
        {
            label: '客户名称',
            prop: 'customerName'
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName'
        },
        {
            label: '签单计划(万)',
            prop: 'cdExpectBiddingSize',
            sort: 'custom'
        },
        {
            label: '预计总规模(万)',
            prop: 'expectedTrafficPlan',
            sort: 'custom'
        },
        {
            label: '运作分公司',
            prop: 'companyName'
        },
        {
            label: '商机大类',
            prop: 'businessType',
            type: 'select',
            optionsKey: 'NEOCRM_BUSINESS_TYPE'
        },
        {
            label: '仓库类型',
            prop: 'warehouseType',
            type: 'select',
            optionsKey: 'NEOCRM_WH_TYPE'
        },
        {
            label: '商机标识',
            prop: 'opportunityTabCn'
        }

        // {
        //     label: '业务类型',
        //     prop: 'businessCategory',
        //     type: 'slot',
        //     optionsKey: 'NEOCRM_BUSINESS_CATEGORY'
        // }
    ],
    notProcessedColumns: [
        {
            label: '商机编码',
            prop: 'opportunityCode',
            minWidth: '110px',
            type: 'slot'
        },
        {
            label: '商机名称',
            prop: 'opportunityName'
        },
        {
            label: '业务预计启动时间',
            prop: 'businessTime'
        },
        {
            label: '客户名称',
            prop: 'customerName'
        },
        {
            label: '运作分公司',
            prop: 'companyName'
        },
        {
            label: '签单计划(万)',
            prop: 'cdExpectBiddingSize'
        },
        {
            label: '预计总规模(万)',
            prop: 'expectedTrafficPlan'
        },

        {
            label: '中标日期',
            prop: 'winningDate'
        }

    ]

};
export const contractConfig = {
    name: 'contractConfig',
    selection: true,
    index: false,
    columns: [
        {
            label: '合同编码',
            prop: 'contractCode'
        },
        {
            label: '合同名称',
            prop: 'contractName',
            type: 'slot',
            minWidth: 100
        },
        {
            label: '合同性质',
            prop: 'contractCharacter',
            type: 'select',
            optionsKey: 'SYS_WM_CONTRACT_CHARACTER'
        },
        {
            label: '项目编码',
            prop: 'projectCodes'
        },
        {
            label: '客户明细',
            prop: 'customerNames'
        },
        {
            label: '客户系名称',
            prop: 'customerGroupNames'
        },
        {
            label: '分公司明细',
            prop: 'companyNames'
        },
        {
            label: '预计年业务量(万元)',
            prop: 'expectedTrafficPlan',
            sort: 'custom'
        },
        {
            label: '生效日期',
            prop: 'validTime',
            sort: 'custom'
        },
        {
            label: '失效日期',
            prop: 'failTime',
            sort: 'custom'
        },
        {
            label: '合同开发人',
            prop: 'salesStaffName'
        },
        {
            label: '合同承接人',
            prop: 'receiverName'
        },
        {
            label: '合同标识',
            prop: 'identification',
            fixed: 'right'
        }

    ],
    othersDraftColumns: [
        {
            label: '合同编码',
            prop: 'contractCode'
        },
        {
            label: '合同性质',
            prop: 'contractCharacter',
            type: 'select',
            optionsKey: 'SYS_WM_CONTRACT_CHARACTER'
        },
        {
            label: '项目编码',
            prop: 'projectCodes'
        },
        {
            label: '客户明细',
            prop: 'customerNames'
        },
        {
            label: '分公司明细',
            prop: 'companyNames'
        },
        {
            label: '生效日期',
            prop: 'validTime'
        },
        {
            label: '失效日期',
            prop: 'failTime'
        },
        {
            label: '合同开发人',
            prop: 'salesStaffName'
        },
        {
            label: '合同承接人',
            prop: 'receiverName'
        },
        {
            label: '创建日期',
            prop: 'createTime'
        }

    ]
};
export const contractRegistrationConfig = {
    name: 'contractRegistrationConfig',
    selection: true,
    index: false,
    columns: [
        {
            label: '客户名称',
            prop: 'customerName',
            minWidth: 200
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            minWidth: 100
        },
        {
            label: '行业',
            prop: 'industryCategoriesName'
        },
        {
            label: '分公司',
            prop: 'companyName',
            minWidth: 90
        },
        {
            label: '经营中心',
            prop: 'businessCenterName',
            minWidth: 140
        },
        {
            label: '分摊类型',
            prop: 'respDivide',
            type: 'select',
            optionsKey: 'NEOCRM_RESP_DIVIDE' // TODO
        },
        {
            label: '责任人1',
            prop: 'ownerName1'
        },
        {
            label: '责任人比例1',
            prop: 'ownerRatio1',
            minWidth: 90
        },
        {
            label: '责任人2',
            prop: 'ownerName2'
        },
        {
            label: '责任人比例2',
            prop: 'ownerRatio2',
            minWidth: 90
        },
        {
            label: '责任人3',
            prop: 'ownerName3'
        },
        {
            label: '责任人比例3',
            prop: 'ownerRatio3',
            minWidth: 90
        },
        {
            label: '责任人4',
            prop: 'ownerName4'

        },
        {
            label: '责任人比例4',
            prop: 'ownerRatio4',
            minWidth: 90
        },
        {
            label: '责任人5',
            prop: 'ownerName5'
        },
        {
            label: '责任人比例5',
            prop: 'ownerRatio5',
            minWidth: 90
        },
        {
            label: '分公司公共池比例',
            prop: 'companyCommonPoolRatio',
            minWidth: 120
        },
        {
            label: '行业公共池比例',
            prop: 'industryCommonPoolRatio',
            minWidth: 120
        },
        {
            label: '最新变更单',
            prop: 'mipUrl',
            type: 'slot',
            minWidth: 130
        },
        {
            label: '单据所有人',
            prop: 'billOwnerName',
            minWidth: 90
        },
        {
            label: '单据所在部门',
            prop: 'billDepartmentName',
            minWidth: 100
        },
        {
            label: '修改日期',
            prop: 'updateTime',
            minWidth: 130
        },
        {
            label: '创建日期',
            prop: 'createTime',
            minWidth: 130,
            sort: true
        },
        {
            label: '提成分配标识',
            prop: 'identification',
            fixed: 'right',
            minWidth: 130
        }

    ]
};
export const commissionConfig = {
    name: 'commissionConfig',
    selection: true,
    index: false,
    columns: [
        {
            label: '用户',
            prop: 'customerCode'
        },
        {
            label: '业务场景',
            prop: 'outsideCustomerName'
        },
        {
            label: '存量/增量',
            prop: 'outsideCustomerName'
        },
        {
            label: '1月',
            prop: 'allmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '2月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '3月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '4月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '5月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '6月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        },
        {
            label: '7月',
            prop: 'gmoney',
            moreHeader: true,
            children: [{
                label: '收入(万)',
                prop: 'currentMonth'
            }, {
                label: '过程提成(元)',
                prop: 'allMonth'
            }]
        }
    ]
};
const customerTableConfig = {
    customer: [
        {
            label: '客户编码',
            prop: 'customerCode'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            propLink: 'customerNameLink',
            type: 'slot',
            minWidth: 100
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            type: 'slot',
            propLink: 'customerNameLink'
        },
        {
            label: '行业',
            prop: 'industryCategoriesName'
        },
        {
            label: '细分行业',
            prop: 'industryTypeName'
        },
        {
            label: '客户等级',
            prop: 'customerLevelCode',
            type: 'slot',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '客户经理',
            prop: 'customerManager'
        },
        {
            label: '年累计收入(万)',
            prop: 'income',
            sort: 'custom'
        },
        // {
        //     label: '利润额(万)',
        //     prop: 'grossFee'
        // },
        {
            label: '逾期应收(万)',
            prop: 'arAmt',
            sort: 'custom'
        }
    ],
    otherCustomer: [
        {
            label: '客户编码',
            prop: 'customerCode'
        },
        {
            label: '客户名称',
            prop: 'customerName',
            propLink: 'customerNameLink',
            type: 'slot',
            minWidth: 100
        },
        {
            label: '客户系名称',
            prop: 'customerGroupName',
            type: 'slot',
            propLink: 'customerNameLink'
        },
        {
            label: '行业',
            prop: 'industryCategoriesName'
        },
        {
            label: '细分行业',
            prop: 'industryTypeName'
        },
        {
            label: '客户等级',
            prop: 'customerLevelCode',
            type: 'slot',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL'
        },
        {
            label: '客户经理',
            prop: 'customerManager'
        }
        // {
        //     label: '年累计收入(万)',
        //     prop: 'income'
        // },
        // {
        //     label: '利润额(万)',
        //     prop: 'grossFee'
        // },
        // {
        //     label: '逾期应收(万)',
        //     prop: 'arAmt'
        // }
    ]
};
/**
 *  角色
 *  "industry" : 行业销售管理/细分行业管理
 *  "personal" : 普通营销/行业组员
 *  "company"  : 分公司销售管理
 *
 * */
export const statusList = {
    customerList: [
        {
            title: '我负责的客户',
            type: '1',
            className: 'bigData-btn-home-page-customer-my-self',
            role: [
                'personal'
            ],
            // routerLink: '/customer-data1',
            content: '本人作为客户经理的客户，收入/利润/应收取今年累计收入（截至上月）',
            listApi: getMyCusomterList,
            columns: customerTableConfig.customer,
            formConfig: customerFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.roleType = params.dataType;
                params.personalType = params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'income';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                return params;
            },
            afterResponse: res => {
                if (res && +res.code === 0 && res.data) {
                    Array.isArray(res.data.list) && res.data.list.forEach(it => {
                        it.arAmt = formatValue(it.arAmt);
                        it.income = formatValue(it.income);
                    });
                }
                return res;
            },
            countList: [{
                title: '年累计收入合计',
                tipField: 'totalAnnualIncome',
                field: '2'
            }, {
                title: '逾期应收合计',
                tipField: 'overdueReceivableTotal',
                field: '1'
            }]
        },
        {
            title: '我参与的客户',
            type: '2',
            className: 'bigData-btn-home-page-customer-my-participation',
            role: [
                'personal'
            ],
            // routerLink: '/customer-data2',
            content: '本人作为客户提成分配规则的参与成员，收入/利润/应收取今年累计收入（截至上月）',
            listApi: getMyCusomterList,
            columns: customerTableConfig.otherCustomer,
            formConfig: customerFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.roleType = params.dataType;
                params.personalType = params.status;
                return params;
            },
            afterResponse: res => {
                if (res && +res.code === 0 && res.data) {
                    Array.isArray(res.data.list) && res.data.list.forEach(it => {
                        it.arAmt = formatValue(it.arAmt);
                        it.income = formatValue(it.income);
                    });
                }
                return res;
            }
        },
        {
            title: '',
            type: '',
            className: 'bigData-btn-home-page-customer-my-participation',
            role: ['organization'],
            // routerLink: '/customer-data2',
            content: '',
            listApi: getMyCusomterList,
            columns: customerTableConfig.customer,
            formConfig: customerFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.roleType = params.dataType;
                params.personalType = params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'income';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                return params;
            },
            afterResponse: res => {
                if (res && +res.code === 0 && res.data) {
                    Array.isArray(res.data.list) && res.data.list.forEach(it => {
                        it.arAmt = formatValue(it.arAmt);
                        it.income = formatValue(it.income);
                    });
                }
                return res;
            },
            countList: [{
                title: '年累计收入合计',
                tipField: 'totalAnnualIncome',
                field: '2'
            }, {
                title: '逾期应收合计',
                tipField: 'overdueReceivableTotal',
                field: '1'
            }]
        }
    ],
    opportunityList: [
        {
            title: '我开发的商机',
            type: '2',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-opportunity-overdue',
            openLink: 'https://annto.my.xiaoshouyi.com/bff/neoweb#/entityGrid/opportunity?objectApiKey=opportunity',
            moreClass: 'bigData-btn-home-page-opportunity-more',
            listApi: getOpportunityList,
            columns: opportunityConfig.columns,
            content: `基层：本人作为商机开发人/团队成员的窗口期小于当月的进行中的商机；
管理层：本区域/行业的商机开发人的窗口期小于当月的进行中的商机；`,
            formConfig: opportunityFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.viewTab = params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'winPeriodWid';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                // params.opportunityTab = '';
                params.regionList = params.regionCodeList;
                params.calCustomerLevelCodeList = params.customerLevelCodeList;
                delete params.status;
                return params;
            },
            afterResponse: res => {
                // 1 - 已逾期，2 - 合同未办理，3 - 待报签
                const opportunityTabData = {
                    1: '已逾期',
                    2: '合同未办理',
                    3: '待报签'
                };
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.cdExpectBiddingSize = formatValue(it.cdExpectBiddingSize);
                        it.opportunityTabCn = it.opportunityTab.split(',')?.map(v => {
                            return opportunityTabData[v];
                        }).join(',') || '';
                    });
                }
                return res;
            },
            searchField: 'opportunityType',
            countList: [{
                title: '已逾期',
                tipField: 'overdueOpportunities',
                field: '1',
                search: true,
                active: false
            }, {
                title: '合同未办理',
                tipField: 'contractNotProcessed',
                field: '2',
                search: true,
                active: false
            }, {
                title: '待报签',
                tipField: 'pendingSignature',
                field: '3',
                search: true,
                active: false
            }]
        },
        {
            title: '我负责客户的商机',
            type: '3',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-opportunity-not-processed',
            openLink: 'https://annto.my.xiaoshouyi.com/bff/neoweb#/entityGrid/opportunity?objectApiKey=opportunity',
            moreClass: 'bigData-btn-home-page-opportunity-more',
            listApi: getOpportunityList,
            // columns: opportunityConfig.notProcessedColumns,
            columns: opportunityConfig.columns,
            content: `基层：本人作为商机开发人/团队成员的未被合同关联的中标商机；
管理层：本区域/行业的商机开发人的未被合同关联的中标商机；`,
            formConfig: opportunityFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.viewTab = params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'winPeriodWid';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                // params.opportunityTab = '';
                params.regionList = params.regionCodeList;
                params.calCustomerLevelCodeList = params.customerLevelCodeList;
                delete params.status;
                return params;
            },
            afterResponse: res => {
                // 1 - 已逾期，2 - 合同未办理，3 - 待报签
                const opportunityTabData = {
                    1: '已逾期',
                    2: '合同未办理',
                    3: '待报签'
                };
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.cdExpectBiddingSize = formatValue(it.cdExpectBiddingSize);
                        it.opportunityTabCn = it.opportunityTab.split(',')?.map(v => {
                            return opportunityTabData[v];
                        }).join(',') || '';
                    });
                }
                return res;
            },
            searchField: 'opportunityType',
            countList: [{
                title: '已逾期',
                tipField: 'overdueOpportunities',
                field: '1',
                search: true,
                active: false
            }, {
                title: '合同未办理',
                tipField: 'contractNotProcessed',
                field: '2',
                search: true,
                active: false
            }, {
                title: '待报签',
                tipField: 'pendingSignature',
                field: '3',
                search: true,
                active: false
            }]
        },
        {
            title: '',
            type: '',
            role: ['organization'],
            className: 'bigData-btn-home-page-opportunity-not-processed',
            openLink: 'https://annto.my.xiaoshouyi.com/bff/neoweb#/entityGrid/opportunity?objectApiKey=opportunity',
            moreClass: 'bigData-btn-home-page-opportunity-more',
            listApi: getOpportunityList,
            // columns: opportunityConfig.notProcessedColumns,
            columns: opportunityConfig.columns,
            content: ``,
            formConfig: opportunityFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.viewTab = params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'winPeriodWid';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                if (!params.status) {
                    params.viewTab = '1';
                }
                delete params.status;
                return params;
            },
            afterResponse: res => {
                // 1 - 已逾期，2 - 合同未办理，3 - 待报签
                const opportunityTabData = {
                    1: '已逾期',
                    2: '合同未办理',
                    3: '待报签'
                };
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.cdExpectBiddingSize = formatValue(it.cdExpectBiddingSize);
                        it.opportunityTabCn = it.opportunityTab.split(',')?.map(v => {
                            return opportunityTabData[v];
                        }).join(',') || '';
                    });
                }
                return res;
            },
            searchField: 'opportunityType',
            countList: [{
                title: '已逾期',
                tipField: 'overdueOpportunities',
                field: '1',
                search: true,
                active: false
            }, {
                title: '合同未办理',
                tipField: 'contractNotProcessed',
                field: '2',
                search: true,
                active: false
            }, {
                title: '待报签',
                tipField: 'pendingSignature',
                field: '3',
                search: true,
                active: false
            }]
        }
        //         {
        //             title: '待报签',
        //             type: '3',
        //             className: 'bigData-btn-home-page-opportunity-pending',
        //             openLink: 'https://annto.my.xiaoshouyi.com/bff/neoweb#/entityGrid/opportunity?objectApiKey=opportunity',
        //             moreClass: 'bigData-btn-home-page-opportunity-more',
        //             listApi: getOpportunityList,
        //             columns: opportunityConfig.columns,
        //             content: `基层：本人作为商机开发人/团队成员的待报签的商机；
        // 管理层：本区域/行业的商机开发人的待报签的商机；`,
        //             beforeRequest: (data) => {
        //                 const params = formatParams(data);
        //                 params.viewTab = params.status;
        //                 params.orderBy = 'oi.win_period_wid';
        //                 params.orderByType = 'asc';
        //                 delete params.status;
        //                 return params;
        //             }
        //         }
    ],
    contractList: [
        {
            title: '我负责客户的合同',
            type: '1',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-contract-expire',
            listApi: getHomePageContract,
            columns: contractConfig.columns,
            content: ``,
            formConfig: contractFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.contractStatus = 2;
                const failTime = getOtherTime();
                params.endFailTime = failTime.endTime;
                params.startFailTime = failTime.startTime;
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                params.orderBy = params.orderBy ? params.orderBy : 'failTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                delete params.status;
                return params;
            },
            afterResponse: res => {
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.identification = '即将到期';
                    });
                }
                return res;
            },
            countList: [{
                title: '即将到期',
                tipField: 'aboutToExpire',
                field: '1'
            }]
        },
        {
            title: '我承接的合同',
            type: '2',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-contract-draft',
            listApi: getHomePageContract,
            columns: contractConfig.columns,
            content: '',
            formConfig: contractFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.contractStatus = 2;
                const failTime = getOtherTime();
                params.endFailTime = failTime.endTime;
                params.startFailTime = failTime.startTime;
                params.orderBy = params.orderBy ? params.orderBy : 'failTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                delete params.status;
                return params;
            },
            afterResponse: res => {
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.identification = '即将到期';
                    });
                }
                return res;
            },
            countList: [{
                title: '即将到期',
                tipField: 'aboutToExpire',
                field: '1'
            }]
        },
        {
            title: '',
            type: '',
            role: ['organization'],
            className: 'bigData-btn-home-page-contract-draft',
            listApi: getHomePageContract,
            columns: contractConfig.columns,
            content: '',
            formConfig: contractFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.contractStatus = 2;
                const failTime = getOtherTime();
                params.endFailTime = failTime.endTime;
                params.startFailTime = failTime.startTime;
                params.orderBy = params.orderBy ? params.orderBy : 'failTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                delete params.status;
                return params;
            },
            afterResponse: res => {
                if (res.data && Array.isArray(res.data.list)) {
                    res.data.list.forEach(it => {
                        it.expectedTrafficPlan = formatValue(it.expectedTrafficPlan);
                        it.identification = '即将到期';
                    });
                }
                return res;
            },
            countList: [{
                title: '即将到期',
                tipField: 'aboutToExpire',
                field: '1'
            }]
        }
    ],
    contractRegistrationList: [
        {
            title: '我负责客户的提成分配规则',
            type: '1',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-registration-draft',
            listApi: getHomepageCustomerManagerArchivePage,
            columns: contractRegistrationConfig.columns,
            content: '',
            formConfig: registrationFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.maintainStatusList = ['1', '2', '4'];
                params.customerOwnerCode = userCode;
                params.calCustomerLevelCodeList = params.customerLevelCodeList;
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                delete params.status;
                params.orderBy = params.orderBy ? params.orderBy : 'createTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                return params;
            },
            afterResponse: res => {
                const obj = {
                    1: '待维护',
                    2: '变更中',
                    4: '变更中'
                };
                if (res.data) {
                    res.data.list.forEach(v => {
                        Object.assign(v, setOwnerList(v.ownerList));
                        v.identification = obj[v.maintainStatus];
                    });
                }
                return res;
            },
            searchField: 'statisticalStateList',
            countList: [{
                title: '待维护',
                tipField: 'pendingMaintenance',
                field: ['1'],
                search: true,
                active: false
            }, {
                title: '变更中',
                tipField: 'underChange',
                field: ['4', '2'],
                search: true,
                active: false
            }]
        },
        {
            title: '我参与的提成分配规则',
            type: '2',
            role: [
                'personal'
            ],
            className: 'bigData-btn-home-page-registration-change',
            listApi: getHomepageCustomerManagerArchivePage,
            columns: contractRegistrationConfig.columns,
            content: '',
            formConfig: registrationFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.maintainStatusList = ['1', '2', '4'];
                params.orderBy = params.orderBy ? params.orderBy : 'createTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                params.ownerCodeList = [userCode];
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                delete params.status;
                return params;
            },
            afterResponse: res => {
                const obj = {
                    1: '待维护',
                    2: '变更中',
                    4: '变更中'
                };
                if (res.data) {
                    res.data.list.forEach(v => {
                        Object.assign(v, setOwnerList(v.ownerList));
                        v.identification = obj[v.maintainStatus];
                    });
                }
                return res;
            },
            searchField: 'statisticalStateList',
            countList: [{
                title: '待维护',
                tipField: 'pendingMaintenance',
                field: ['1'],
                search: true,
                active: false
            }, {
                title: '变更中',
                tipField: 'underChange',
                field: ['4', '2'],
                search: true,
                active: false
            }]
        },
        {
            title: '',
            type: '',
            role: ['organization'],
            className: 'bigData-btn-home-page-registration-change',
            listApi: getHomepageCustomerManagerArchivePage,
            columns: contractRegistrationConfig.columns,
            content: '',
            formConfig: registrationFormConfig,
            beforeRequest: (data) => {
                const params = formatParams(data);
                params.maintainStatusList = ['1', '2', '4'];
                params.orderBy = params.orderBy ? params.orderBy : 'createTime';
                params.orderByType = params.orderByType ? params.orderByType : 'desc';
                params.queryTag = params.status;
                if (!params.status) {
                    params.queryTag = '3';
                }
                delete params.status;
                return params;
            },
            afterResponse: res => {
                const obj = {
                    1: '待维护',
                    2: '变更中',
                    4: '变更中'
                };
                if (res.data) {
                    res.data.list.forEach(v => {
                        Object.assign(v, setOwnerList(v.ownerList));
                        v.identification = obj[v.maintainStatus];
                    });
                }
                return res;
            },
            searchField: 'statisticalStateList',
            countList: [{
                title: '待维护',
                tipField: 'pendingMaintenance',
                field: ['1'],
                search: true,
                active: false
            }, {
                title: '变更中',
                tipField: 'underChange',
                field: ['4', '2'],
                search: true,
                active: false
            }]
        }
    ]
};
export const opportunityFormList = [
    {
        label: '本月有效商机规模(万)',
        prop: 'monthValidOpportunityAmount',
        content: `基层：本人作为商机开发人的有效商机规模；
管理层：本人所辖区域/行业的有效商机规模；
数据来自：销售易的进行中/赢单商机，按窗口期（实时）`
    },
    // {
    //     label: '当月收入预测(万)', prop: 'abc2'
    // },
    {
        label: '本月到期合同数',
        prop: 'monthExpiringContractCount',
        content: `基层：本人作为合同开发人/承接人的合同数；
管理层：本人所辖区域/行业的合同数；
数据来自：LCRM的外部业务合同，按合同失效日期（实时）`
    },
    // {
    //     label: '当年收入客户数',
    //     prop: 'yearIncomeCustomerCount',
    //     content: `基层：本人作为客户经理的客户数量；
    // 管理层：本人所辖区域/行业的客户数量；
    // 数据来自：大数据的盈利分析汇总收入，按收入日期（基于昨天）`
    // },
    {},
    {
        label: '当年利润额(万)',
        prop: 'yearProfitAmount',
        content: `基层：本人作为客户经理的客户总利润额；
管理层：本人所辖区域/行业的客户总利润额；
数据来自：大数据的利润表，按收入日期（基于昨天）`
    },
    {
        label: '逾期应收(万)',
        prop: 'monthArAmt',
        content: `基层：本人作为客户经理的客户总逾期应收额；
管理层：本人所辖区域/行业的客户总逾期应收额；
数据来自：大数据的逾期应收表，按应收日期（基于昨天）`
    }
];
export const homePageTipsContent = {
    coreYearIncome: `基层：本人作为客户经理的客户总收入；
管理层：本人所辖区域/行业的客户总收入；
数据来自：大数据的盈利分析汇总收入，按收入日期（基于昨天）`,
    coreYearSignBill: `基层：本人作为商机开发人的签单规模；
管理层：本人所辖区域/行业的签单规模；
数据来自：销售易的中标/合同签订商机，按中标日期（实时）`,
    incomeYearpersonal: `指标说明：收入
    取数口径

1. 收入：即主营业务收入，为业务类型剔除“其他业务"、“资产转卖”后的不含税收入
2. 预算：每年初由指标业务负责人导入 1）日维度：预算日均值=当月预算/当月总天数
    2）月维度：预算达成率=当月达成/当月预算
    3）年维度：全年预算为当年1月~12月的预算求和，累计预算为1月~当月的预算求和，全年预算达成率=年度达成/全年预算，累计预算达成率=年度达成/累计预算
3. 为区分菜鸟系的渠道客户和纯外部客户，将内外渠属性为渠道且客户系为菜鸟的收入拆分出来归入“菜鸟美的”这一单独内外渠属性中
4. 环同比：日维度环比=当日达成/上日达成，同比=当日达成/上一年同日达成；月维度环比=当月达成/上月累计同日达成，同比=当月达成/上一年同月累计同日达成；年维度同比=年度达成/上一年累计同日达成
5. 数据来源：1)水晶球物流->盈利持续->盈利分析汇总；2)补录平台中的“收入成本补录”表；3)补录平台中的“驾驶舱收入执行预算补录”表
注：
数据更新频率和范围：每天凌晨更新一次数据，每次更新当月所有数据
业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    incomeYear: `指标说明：收入
    取数口径

1. 收入：即主营业务收入，为业务类型剔除“其他业务"、“资产转卖”后的不含税收入
2. 环同比：日维度环比=当日达成/上日达成，同比=当日达成/上一年同日达成；月维度环比=当月达成/上月累计同日达成，同比=当月达成/上一年同月累计同日达成；年维度同比=年度达成/上一年累计同日达成
3. 数据来源：1)水晶球物流->盈利持续->盈利分析汇总；2)补录平台中的“收入成本补录”表；3)补录平台中的“驾驶舱收入执行预算补录”表
注：
数据更新频率和范围：每天凌晨更新一次数据，每次更新当月所有数据
业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    opportunitypersonal: `指标说明：商机规模
    取数口径

1.数据来源：①商机来源于销售易系统->项目/商机管理->商机；②签单目标来源于业务补录
2.更新时间：每天凌晨2点和中午12点更新最后一次修改时间在24小时内的商机
3.计算口径：
    ①总商机规模：满足下面4项条件的商机的签单计划之和
        a.商机状态为待调研、调研中、已调研、已报价、待报签、已签单、已落标；
        b.分公司不是业务平台；
        c.行业不为绿色回收、网货、油品；
        d.专司不为空值，即商机大类、业务类别不为空
    ②有效商机规模: 总商机规模剔除掉商机状态为已落标且落标原因是“商机替换”、“无效商机”的商机规模
    ③商机覆盖比=有效商机规模/签单目标
业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    opportunity: `指标说明：商机规模
    取数口径

1.数据来源：①商机来源于销售易系统->项目/商机管理->商机；②签单目标来源于业务补录
2.更新时间：每天凌晨2点和中午12点更新最后一次修改时间在24小时内的商机
3.计算口径：
    ①总商机规模：满足下面4项条件的商机的签单计划之和
        a.商机状态为待调研、调研中、已调研、已报价、待报签、已签单、已落标；
        b.分公司不是业务平台；
        c.行业不为绿色回收、网货、油品；
        d.专司不为空值，即商机大类、业务类别不为空
    ②有效商机规模: 总商机规模剔除掉商机状态为已落标且落标原因是“商机替换”、“无效商机”的商机规模
业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    overdue: `指标说明：逾期应收
    取数口径

1. 应收账款=逾期账款+本月到期+未到期
逾期率 = 逾期账款 / 应收账款
2. 业务口径：根据距 业务月+2个月 的时间差确认是否逾期及逾期时间，其中
逾期账款 = 当月>业务月+2个月 的应收账款
本月到期 = 当月=业务月+2个月 的应收账款
未到期 = 当月<业务月+2个月 的应收账款
逾期时间 = [当月-业务月-2] * 30天
责任制逾期率 = 逾期30天以上的逾期账款 / 应收账款
外渠责任制逾期率 = [外部和渠道的逾期30天以上的逾期账款] / 应收账款
3. 合同口径：
(1) 2022/4/1之前，根据合同到期日确认是否逾期及逾期时间，其中
合同到期日 = 开票日 + 合同账期
逾期账款：当日>合同到期日 的已开票应收账款
本月到期：当日<=合同到期日 and 合同到期日在当月 的已开票应收账款
未到期=[当日<合同到期日 and 合同到期日不在当月的已开票应收账款] + [未开票的应收账款]
逾期时间 = 当日 - 合同到期日
(2) 从2022/4/1起，对于已开票的应收账款，根据合同到期日确认是否逾期及逾期时间；对于未开票的应收账款，根据业务月+2个月确认是否逾期及逾期时间，其中
逾期账款 = [当日>合同到期日 的已开票应收账款] + [当月>业务月+2个月 的未开票应收账款]
本月到期 = [当日<=合同到期日 and 合同到期日在当月 的已开票应收账款] + [当月=业务月+2个月 的应收账款]
未到期= [当日<合同到期日 and 合同到期日不在当月 的已开票应收账款] + [当月<业务月+2个月 的应收账款]
逾期时间 = {已开票： 当日 - 合同到期日} or { 未开票： [当月-业务月-2] * 30天}

注：
1. 更新频率：每日凌晨更新前一天数据
2. 数据来源：水晶球物流- 风险可控-应收账款 and 水晶球物流- 风险可控-应收发票账龄明细
3. 剔除了分公司为支持职能的数据
4. 月维度数据为每月最后一天的数据（若当月未过完则为前一天），年维度数据为每年最后一天的数据（如果当年未过完则为前一天）
5. 合同口径从2021年4月才有逾期和本月到期数据，且因月度数据取的是月底最后一天的数据，所以月度数据本月到期值都相对较小；另因2022年4月1日修改了合同口径逻辑，故2022年4月1日之前已开票和未开票tab下的数据不完整不建议参考
业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    orderpersonal: `指标说明：签单达成
    取数口径

1.数据来源：①签单达成来源于销售易系统->项目/商机管理->商机；②签单目标来源于业务补录
2.更新时间：每天凌晨2点和中午12点更新最后一次修改时间在24小时内的商机
3.计算口径：
①签单类别判断逻辑：
CDC：商机大类为基地仓的商机；
RDC(渠道)：商机大类为大件仓配、快消仓配、大件2C其中之一，细分行业为家电经销、快消经销/区域客户、商超连锁其中之一的商机；
RDC(品牌)：商机大类为大件仓配、快消仓配、大件2C其中之一，细分行业不为家电经销、快消经销/区域客户、区域客户、商超连锁其中之一的商机；
小件电商：商机大类为小件电商的商机；
其它：不符合上面任一种的商机
②签单达成：满足下面4项条件的商机的签单计划金额
a. 销售阶段为中标确认和合同签订
b. 分公司不是业务平台且片区不为空；
c. 行业不为绿色回收、网货、油品；
d. 专司不为空值，即商机大类、业务类别不为空
③签单达成率=签单达成/签单目标*100%
④年度签单达成率=本年度签单达成/全年签单目标*100%

业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    order: `取数口径

1.数据来源：①签单达成来源于销售易系统->项目/商机管理->商机；
2.更新时间：每天凌晨2点和中午12点更新最后一次修改时间在24小时内的商机
3.计算口径：
①签单类别判断逻辑：
CDC：商机大类为基地仓的商机；
RDC(渠道)：商机大类为大件仓配、快消仓配、大件2C其中之一，细分行业为家电经销、快消经销/区域客户、商超连锁其中之一的商机；
RDC(品牌)：商机大类为大件仓配、快消仓配、大件2C其中之一，细分行业不为家电经销、快消经销/区域客户、区域客户、商超连锁其中之一的商机；
小件电商：商机大类为小件电商的商机；
其它：不符合上面任一种的商机
②签单达成：满足下面4项条件的商机的签单计划金额
a. 销售阶段为中标确认和合同签订
b. 分公司不是业务平台且片区不为空；
c. 行业不为绿色回收、网货、油品；
d. 专司不为空值，即商机大类、业务类别不为空

业务负责人覃彬航（tanbh7）

IT对接人陈乐（chenle39）`,
    signReversalAmtQD: `1.每月的签单达成数据在月底会被冻结
2.若冻结后前期签单达成数据有变化，则在变化月做冲销`,
    totalAnnualIncome: `单位万元，取在当前筛选条件下，各客户今年累计收入的合计。`,
    overdueReceivableTotal: `单位万元，取在当前筛选条件下，各客户当月逾期应收合计。`,
    overdueOpportunities: `展示在当前筛选条件下，窗口期小于当月，销售阶段不等于中标确认/合同签订/落标的商机总和，点击可筛选已逾期商机。`,
    contractNotProcessed: `展示在当前筛选条件下，中标确认，未被合同关联的商机，点击可筛选合同未办理商机。`,
    pendingSignature: `展示商机状态=待报签的商机，点击可筛选待报签商机。`,
    aboutToExpire: `统计当前筛选条件下，即将到期的合同数量（合同状态=有效，失效日期在未来3个月（月底））。`,
    pendingMaintenance: `展示维护状态=草稿的客户提成分配规则，点击可筛选待维护提成分配规则。`,
    underChange: `展示维护状态=维护中/变更中的客户提成分配规则，点击可筛选变更中提成分配规则。`,
    complaint: `客户KPI达成率：
1、TOP客户KPI合格率=∑（客户标准+安得标准KPI合格的客户数或运作点数）/∑（客户标准+安得标准KPI的客户总数或运作点总数）。
【结果报表：数据银行-客户KPI达成率统计表-TOP客户KPI合格率统计表】
备注：①客户标准：ICS客户服务管理系统-客户标准KPI管理  考核时间：1月1日-当月月底，合格次数/总次数，客户等级为TOP.
②安得标准：数据银行-外部客户KPI集成报表，以经营中心+客户系作为一个运作点。客户等级为TOP。
客户标准最终得分高于90分客户数/客户标准总客户数；
当月达成取当月值，累计达成取累计值（其中全程时效兑现率为改约后兑现率）。
已有客户标准的只取客户标准。
抖音、淘天物流、益美、唯品会、拼多多、菜鸟系、欧派、三菱重工、海信不计入。
2、普通/CKA客户KPI合格率=∑（客户标准+安得标准KPI达标的客户数或运作点数）/∑（客户标准+安得标准KPI的客户总数或运作点总数）
【结果报表：数据银行-客户KPI达成率统计表-普通/CKA客户KPI合格率统计表】
备注：①客户标准：ICS客户服务管理系统-客户标准KPI管理  考核时间：1月1日-当月月底，合格次数/总次数，客户等级为CKA+普通。
②安得标准：数据银行-外部客户KPI集成报表，以经营中心+客户系作为一个运作点。客户等级为CKA+普通。
客户标准最终得分高于90分客户数/客户标准总客户数；
当月达成取当月值，累计达成取累计值（其中全程时效兑现率为改约后兑现率）。
已有客户标准的只取客户标准。
3、外部客户KPI整体达成率=TOP客户KPI合格率*X%+普通/CKA客户KPI达成率*X%（说明：X%对应规模占比）

外部客诉率：
（分子：数据来源:ICS-工单明细报表-工单类型为“投诉”的工单、客户属性筛选：纯外部；按以下规则筛选后，以“客户名称”去重，得出【投诉客户数】作为分子）
1、客户名称剔除“美的”字样；
2、剔除“订单来源系统”=“菜鸟”工单
3、剔除一级问题分类为“逆向协同”工单。
4、工单状态剔除：作废、未流转工单和待下发工单；
5、责任环节剔除：仓（2C）、配（2C）、送装；
6、业务场景：剔除大件电商、供应商、送装业务、美的业务、网络货运；
7、剔除工单来源为：微信（吐槽）、客户门户、客户小程序、美云销（催单）、美云销（差评）、美云销（店铺）、菜鸟、京东UE、拼多多、淘天物流、小b客户拜访管理、OTP城配系统、微信在线客服
8、剔除客户系为“美的系”工单
9、剔除“三级问题分类”为“结算资源”工单
10、剔除“业务模式”为“B2C”工单
11、【剔除“工单来源”为“分公司”工单】
以上筛选后按照客户名称去重，所对应的客户数量作为分子。
分母：盈利分析收入汇总-业务,日期：当月1日至月末日期；客户属性外部，客户收入不为零的客户数）`,
    satisfactionOrder: `外部客户满意度：
外部客户满意度=外部甲方满意客户数/（外部甲方满意客户数+不满意客户数）
取数口径：ICS客户服务管理系统-满意度管理-满意度  外部甲方满意客户数/（外部甲方满意客户数+不满意客户数）
单个客户各细项维度均满意，整体视为满意。若其中有一项及以上不满意，则该次结果为不满意。

外部工单闭环及时率：
工单闭环及时率=及时闭环工单数量/工单总数量（不含废弃等无效工单）
（分子：数据来源:ICS工单明细报表-客户属性筛选：纯外部；
1、客户名称剔除“美的”字样；
2、剔除“订单来源系统”=“菜鸟”工单
3、剔除一级问题分类为“逆向协同”工单。
4、工单状态剔除：作废、未流转工单和待下发工单；
5、责任环节剔除：仓（2C）、配（2C）、送装；
6、业务场景：剔除大件电商、供应商、送装业务、美的业务、网络货运；
7、剔除工单来源为：微信（吐槽）、客户门户、客户小程序、美云销（催单）、美云销（差评）、美云销（店铺）、菜鸟、京东UE、拼多多、淘天物流、小b客户拜访管理、OTP城配系统、微信在线客服
8、剔除客户系为“美的系”工单
9、剔除“三级问题分类”为“结算资源”工单
10、剔除“业务模式”为“B2C”工单`
};

export const chartsConfig = {
    incomeYear: {
        title: '收入概览',
        routerLink: 'incomeOverview',
        titleTips: homePageTipsContent.incomeYear,
        titleTipsPersonal: homePageTipsContent.incomeYearpersonal,
        titleTipsProp: 'incomeOverview',
        classNameMore: 'bigData-btn-home-page-income-overview-more',
        chartTitle: '趋势图',
        type: 'line',
        upRedIcon: true, // 状态红色上升
        headConfig: [
            {
                title: '年度达成',
                titleProp: 'incomeFee',
                filedName1: '同比',
                filedProp1: 'incomeFeeY2Y'
            },
            {
                title: '全年预算',
                titleProp: 'planFee',
                filedProp1: 'planRate',
                filedName1: '达成率',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '累计预算',
                titleProp: 'addPlanFee',
                filedProp1: 'addPlanRate',
                filedName1: '达成率',
                isHiddenPersonal: true,
                showIcon: false
            }
        ],
        chartsConfig: {
            prop1: 'incomeFeeYear',
            prop2: 'planIncomeFeeYear',
            prop3: 'incomeFeePI',
            prop4: 'dataTime'
        }
    },
    incomeMonth: {
        title: '收入概览',
        routerLink: 'incomeOverview',
        chartTitle: '趋势图',
        classNameMore: 'bigData-btn-home-page-income-overview-more',
        titleTips: homePageTipsContent.incomeYear,
        titleTipsPersonal: homePageTipsContent.incomeYearpersonal,
        titleTipsProp: 'incomeOverview',
        type: 'line',
        upRedIcon: true, // 状态红色上升
        headConfig: [
            {
                title: '月度达成',
                titleProp: 'incomeFee',
                filedProp1: 'incomeFeeM2M',
                filedName1: '环比',
                filedProp2: 'incomeFeeY2Y',
                filedName2: '同比'
            },
            {
                title: '预算',
                titleProp: 'planFee',
                filedProp1: 'planRate',
                filedName1: '达成率',
                isHiddenPersonal: true,
                showIcon: false
            }
        ],
        headConfigAccumulative: [
            {
                title: '月累计达成',
                titleProp: 'incomeFee',
                filedProp1: 'incomeFeeY2Y',
                filedName1: '同比'
            },
            {
                title: '预算',
                titleProp: 'planFee',
                filedProp1: 'planRate',
                filedName1: '达成率',
                isHiddenPersonal: true,
                showIcon: false
            }
        ],
        chartsConfig: {
            prop1: 'incomeFeeYear',
            prop2: 'planIncomeFeeYear',
            prop3: 'incomeFeePI',
            prop4: 'dataTime'
        }
    },
    opportunityYear: {
        title: '商机概览',
        type: 'pieTable',
        routerLink: 'businessOverview',
        classNameMore: 'bigData-btn-home-page-opportunity-overview-more',
        upRedIcon: true, // 状态红色上升
        titleTips: homePageTipsContent.opportunity,
        titleTipsPersonal: homePageTipsContent.opportunitypersonal,
        titleTipsProp: 'opportunityOverview',
        customHeight: true,
        chartTitle: '各维度总商机规模占比图',
        showRadio: true,
        headConfig: [
            {
                title: '有效商机规模',
                titleProp: 'showValueSJ',
                filedProp1: 'showValueY2YSJ',
                filedName1: '同比',
                style: {
                    flex: '2.5'
                }

            },
            {
                title: '总商机规模',
                titleProp: 'showValueSJ_Total'
            },
            {
                title: '承诺签单规模',
                titleProp: 'salesBeSignedSJ'
            },
            {
                title: '商机覆盖比',
                titleProp: 'reachRateSJ',
                isHiddenPersonal: true
            }
        ],
        tableData: {
            columns: [
                {
                    label: '商机状态',
                    prop: 'opportunityStatusN',
                    minWidth: 220,
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '总商机规模',
                    prop: 'targetValueCn',
                    minWidth: 220,
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'projectRatioCn',
                    align: 'center'
                }
            ],
            columnsOther: [
                {
                    label: '商机大类',
                    prop: 'businessTypeN',
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '总商机规模',
                    prop: 'targetValueCn',
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'businessTypeRatioCn',
                    align: 'center'
                }
            ]
        },
        chartsConfig: {
            name: 'opportunityStatusN',
            value: 'targetValue',
            rote: 'projectRatio',
            colorList: ['#3aadfe', '#71e3fe', '#59e2ac', '#ffd162', '#ff994f', '#ff7876', '#a92823', '#c1c0c5']
        },
        chartsOtherConfig: {
            name: 'businessTypeN',
            value: 'targetValue',
            rote: 'businessTypeRatio',
            colorList: ['#3aadfe', '#71e3fd', '#59e2ac', '#ff9951', '#ff7978', '#ffd162']
        }
    },
    opportunityMonth: {
        title: '商机概览',
        type: 'pieTable',
        routerLink: 'businessOverview',
        classNameMore: 'bigData-btn-home-page-opportunity-overview-more',
        upRedIcon: true, // 状态红色上升
        titleTips: homePageTipsContent.opportunity,
        titleTipsPersonal: homePageTipsContent.opportunitypersonal,
        titleTipsProp: 'opportunityOverview',
        customHeight: true,
        chartTitle: '各维度总商机规模占比图',
        showRadio: true,
        headConfig: [
            {
                title: '有效商机规模',
                titleProp: 'showValueSJ',
                filedProp1: 'showValueM2MSJ',
                filedName1: '环比',
                filedProp2: 'showValueY2YSJ',
                filedName2: '同比',
                style: {
                    flex: '2.5'
                }

            },
            {
                title: '总商机规模',
                titleProp: 'showValueSJ_Total'
            },
            {
                title: '承诺签单规模',
                titleProp: 'salesBeSignedSJ'
            },
            {
                title: '商机覆盖比',
                titleProp: 'reachRateSJ',
                isHiddenPersonal: true
            }
        ],
        tableData: {
            columns: [
                {
                    label: '商机状态',
                    prop: 'opportunityStatusN',
                    minWidth: 115,
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '总商机规模',
                    prop: 'targetValueCn',
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'projectRatioCn',
                    align: 'center'
                }
            ],
            columnsOther: [
                {
                    label: '商机大类',
                    prop: 'businessTypeN',
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '总商机规模',
                    prop: 'targetValueCn',
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'businessTypeRatioCn',
                    align: 'center'
                }
            ]
        },
        chartsConfig: {
            name: 'opportunityStatusN',
            value: 'targetValue',
            rote: 'projectRatio',
            colorList: ['#3aadfe', '#71e3fe', '#59e2ac', '#ffd162', '#ff994f', '#ff7876', '#a92823', '#c1c0c5']
        },
        chartsOtherConfig: {
            name: 'businessTypeN',
            value: 'targetValue',
            rote: 'businessTypeRatio',
            colorList: ['#3aadfe', '#71e3fd', '#59e2ac', '#ff9951', '#ff7978', '#ffd162']
        }
    },
    overdueYear: {
        title: '逾期应收概览',
        type: 'pie',
        routerLink: 'overdueOverview',
        classNameMore: 'bigData-btn-home-page-overdue-overview-more',
        upRedIcon: false, // 状态红色上升
        chartTitle: '',
        titleTips: homePageTipsContent.overdue,
        titleTipsProp: 'overdueOverview',
        headConfig: [
            {
                title: '应收账款',
                titleProp: 'arAmt',
                filedProp1: 'arAmtY2Y',
                filedName1: '同比'
            },
            {
                title: '逾期账款',
                titleProp: 'amtOverdue',
                filedProp1: 'amtOverdueM2M',
                filedName1: '环比',
                filedProp2: 'amtOverdueY2Y',
                filedName2: '同比',
                filedProp3: 'overdueRate',
                filedName3: '逾期'
            },
            {
                title: '本月到期',
                titleProp: 'amtDue'
            }
        ],
        chartsConfig: {
            name: 'name',
            value: 'value',
            rote: 'ratio'
        }

    },
    overdueMonth: {
        title: '逾期应收概览',
        type: 'pie',
        routerLink: 'overdueOverview',
        classNameMore: 'bigData-btn-home-page-overdue-overview-more',
        upRedIcon: false, // 状态红色上升
        chartTitle: '',
        titleTips: homePageTipsContent.overdue,
        titleTipsProp: 'overdueOverview',
        headConfig: [
            {
                title: '应收账款',
                titleProp: 'arAmt',
                filedProp1: 'arAmtM2M',
                filedName1: '环比',
                filedProp2: 'arAmtY2Y',
                filedName2: '同比'
            },
            {
                title: '逾期账款',
                titleProp: 'amtOverdue',
                filedProp1: 'amtOverdueM2M',
                filedName1: '环比',
                filedProp2: 'amtOverdueY2Y',
                filedName2: '同比',
                filedProp3: 'overdueRate',
                filedName3: '逾期'
            },
            {
                title: '本月到期',
                titleProp: 'amtDue'
            }
        ],
        chartsConfig: {
            name: 'name',
            value: 'value',
            rote: 'ratio'
        },
        chartsOtherConfig: {
            name: 'name',
            value: 'value',
            rote: 'ratio'
        }

    },
    orderYear: {
        title: '签单概览',
        customHeight: true,
        routerLink: 'signingOverview',
        classNameMore: 'bigData-btn-home-page-order-overview-more',
        titleTips: homePageTipsContent.order,
        titleTipsPersonal: homePageTipsContent.orderpersonal,
        titleTipsProp: 'orderOverview',
        chartTitle: '签单类别占比图',
        type: 'pieTable',
        upRedIcon: true, // 状态红色上升
        showRadio: false,
        headConfig: [
            {
                title: '当年达成',
                titleProp: 'showValueQD',
                filedProp1: 'showValueY2YQD',
                filedName1: '同比',
                style: {
                    flex: '2'
                }

            },
            {
                title: '当年签单目标',
                titleProp: 'targetVlueQD',
                filedProp1: 'reachRateQD',
                filedName1: '达成率',
                style: {
                    flex: '2'
                },
                isHiddenPersonal: true
            },
            {
                title: '签单累计目标',
                titleProp: 'targetVlueAddQD',
                filedProp1: 'reachRateAddQD',
                filedName1: '达成率',
                style: {
                    flex: '2'
                },
                isHiddenPersonal: true
            }

        ],
        tableData: {
            columns: [
                {
                    label: '签单类别',
                    prop: 'businessTypeN',
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '签单规模',
                    prop: 'targetValueCn',
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'businessTypeRatioCn',
                    align: 'center'
                }

            ]
        },
        chartsConfig: {
            name: 'businessTypeN',
            value: 'targetValue',
            rote: 'businessTypeRatio',
            colorList: ['#39adfe', '#71e3fe', '#59e2ac', '#ffd162', '#ff9951']
        }
    },
    orderMonth: {
        title: '签单概览',
        routerLink: 'signingOverview',
        classNameMore: 'bigData-btn-home-page-order-overview-more',
        customHeight: true,
        titleTips: homePageTipsContent.order,
        titleTipsPersonal: homePageTipsContent.orderpersonal,
        titleTipsProp: 'orderOverview',
        chartTitle: '签单类别占比图',
        type: 'pieTable',
        upRedIcon: true, // 状态红色上升
        showRadio: false,
        headConfig: [
            {
                title: '当月达成',
                titleProp: 'showValueQD',
                filedProp1: 'showValueM2MQD',
                filedName1: '环比',
                filedProp2: 'showValueY2YQD',
                filedName2: '同比',
                style: {
                    flex: '2'
                }

            },
            {
                title: '当月签单目标',
                titleProp: 'targetVlueQD',
                filedProp1: 'reachRateQD',
                filedName1: '达成率',
                style: {
                    flex: '2'
                },
                isHiddenPersonal: true
            },
            {
                title: '本月冲销前期签单计划金额',
                titleProp: 'signReversalAmtQD',
                titleTipsProp: 'orderTargetOverview',
                titleTips: homePageTipsContent.signReversalAmtQD,
                isHiddenPersonal: true
            }
        ],
        tableData: {
            columns: [
                {
                    label: '签单类别',
                    prop: 'businessTypeN',
                    align: 'center',
                    slot: true,
                    type: 'slot',
                    editSlot: true
                },
                {
                    label: '签单规模',
                    prop: 'targetValueCn',
                    align: 'center'
                },
                {
                    label: '占比',
                    prop: 'businessTypeRatioCn',
                    align: 'center'
                }

            ]
        },
        chartsConfig: {
            name: 'businessTypeN',
            value: 'targetValue',
            rote: 'businessTypeRatio',
            colorList: ['#39adfe', '#71e3fe', '#59e2ac', '#ffd162', '#ff9951']
        }
    }

};
export const searchListConfig = [
    {
        prop: 'ebcdCode',
        name: '专业公司',
        type: 'select',
        placeholder: '请选择专业公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-page-search-areaCode'
    },
    {
        prop: 'industryCategory',
        name: '行业大类',
        type: 'cascader',
        props: {
            multiple: true,
            value: 'code',
            label: 'name'
        },
        placeholder: '请选择行业大类',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-page-search-industryCategory'
    },
    {
        prop: 'areaCode',
        name: '片区',
        type: 'select',
        placeholder: '请选择片区',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-page-search-areaCode'
    },
    {
        prop: 'subBranchCode',
        name: '分公司',
        type: 'select',
        placeholder: '请选择分公司',
        multiple: true,
        optionsKey: '',
        className: 'bigData-btn-home-page-search-subBranchCode'
    },
    // {
    //     prop: 'businessSceneBigCategory',
    //     name: '业务场景',
    //     type: 'select',
    //     placeholder: '请选择业务场景',
    //     multiple: true,
    //     optionsKey: ''
    // },
    // {
    //     prop: 'bigEbcdName',
    //     name: '大专司',
    //     type: 'select',
    //     placeholder: '请选择大专司',
    //     multiple: false,
    //     defaultValue: '整体',
    //     options: [
    //         {
    //             code: '整体',
    //             name: '整体'
    //         },
    //         {
    //             code: '城配送装',
    //             name: '城配送装'
    //         },
    //         {
    //             code: '零担干线',
    //             name: '零担干线'
    //         },
    //         {
    //             code: '生产物流',
    //             name: '生产物流'
    //         },
    //         {
    //             code: '非专司',
    //             name: '非专司'
    //         }
    //     ]
    // },
    {
        prop: 'customerlevelName',
        name: '客户等级',
        type: 'radio',
        placeholder: '请选择客户等级',
        fixed: 'left',
        className: 'bigData-btn-home-page-search-customerlevel-name'
    },
    {
        prop: 'timeStatus',
        name: '时间',
        type: 'time',
        placeholder: '请选择时间',
        fixed: 'right',
        className: 'bigData-btn-home-page-search-time-name'

    }
];
export const whileList = ['search', 'index', 'orgincomeOverview', 'orgbusinessOverview', 'orgoverdueOverview',
    'orgsigningOverview', 'orgcomplaintView', 'orgsatisfactionOrderView', 'personalincomeOverview', 'personalbusinessOverview', 'personaloverdueOverview',
    'personalsigningOverview', 'personalcomplaintView', 'personalsatisfactionOrderView'];

export const custoemrComplaintConfig = {
    complaintOrg: {
        title: '客户KPI及客诉',
        routerLink: 'complaintView',
        titleTips: homePageTipsContent.complaint,
        titleTipsPersonal: homePageTipsContent.complaint,
        titleTipsProp: 'complaintView',
        classNameMore: 'bigData-btn-home-page-income-overview-more',
        upRedIcon: true, // 状态红色上升
        headConfig: [
            {
                title: '行业KPI得分',
                titleProp: 'kpiAchievementRate'
            },
            {
                title: '行业KPI排名',
                titleProp: 'kpiAchievementRank',
                isHiddenPersonal: true,
                showIcon: false
                // titleRankProp: 'efftivePct2'
            },
            {
                title: '重大客诉发生数量',
                titleProp: 'majorSumCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '重大投诉',
                titleProp: 'majorComplaintsCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '重大问责',
                titleProp: 'majorAccountabilityCnt',
                isHiddenPersonal: true,
                showIcon: false
            }
        ]

    },
    complaintPersonal: {
        title: '客户KPI及客诉',
        routerLink: 'complaintView',
        titleTips: homePageTipsContent.complaint,
        titleTipsPersonal: homePageTipsContent.complaint,
        titleTipsProp: 'incomeOverview',
        classNameMore: 'bigData-btn-home-page-income-overview-more',
        upRedIcon: true, // 状态红色上升
        headConfig: [
            {
                title: 'KPI得分',
                titleProp: 'kpiAchievementRate'
            },
            {
                title: 'KPI排名',
                titleProp: 'kpiAchievementRank',
                isHiddenPersonal: true,
                showIcon: false
                // titleRankProp: 'efftivePct2'
            },
            {
                title: '重大客诉发生数量',
                titleProp: 'majorSumCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '重大投诉',
                titleProp: 'majorComplaintsCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '重大问责',
                titleProp: 'majorAccountabilityCnt',
                isHiddenPersonal: true,
                showIcon: false
            }
        ]

    },
    satisfactionOrder: {
        title: '客户满意度及工单',
        routerLink: 'satisfactionOrderView',
        titleTips: homePageTipsContent.satisfactionOrder,
        titleTipsPersonal: homePageTipsContent.satisfactionOrder,
        titleTipsProp: 'incomeOverview',
        classNameMore: 'bigData-btn-home-page-income-overview-more',
        chartTitle: '趋势图',
        upRedIcon: true, // 状态红色上升
        headConfig: [
            {
                title: '客户满意度',
                titleProp: 'satisfiedPct'
            },
            {
                title: '接通率',
                titleProp: 'efftivePct',
                isHiddenPersonal: true,
                showIcon: false
                // titleRankProp: 'efftivePct2'
            },
            {
                title: '工单总数量',
                titleProp: 'sumCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '闭环及时率',
                titleProp: 'sumInTimePct',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '投诉工单',
                titleProp: 'complaintsCnt',
                isHiddenPersonal: true,
                showIcon: false
            },
            {
                title: '异常工单',
                titleProp: 'abnormalCnt',
                isHiddenPersonal: true,
                showIcon: false
            }
        ]

    }

};
